
<div v-if="data" class="d-flex align-center">
  <div v-if="data?.category" class="d-flex align-center">
    <!-- file -->
    <div v-if="data?.category === 'file' && data?.file" class="d-flex align-center">
      <!-- excel -->
      <div v-if="data?.file.includes('xls') || data?.file.includes('csv')"
        class="d-flex align-center justify-center"
        style="border: 1px solid #0F783E; background-color: #e7f1eb; padding: 0px 8px"
        :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
      >
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #0F783E">
          Excel
        </div>
      </div>
      <!-- image -->
      <div v-else-if="data?.file.includes('jpg') || data?.file.includes('jpeg') || data?.file.includes('png')"
        class="d-flex align-center justify-center"
        style="border: 1px solid #2236E3; background-color: #e8ebfc; padding: 0px 8px"
        :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
      >
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #2236E3">
          Img
        </div>
      </div>
      <!-- pdf -->
      <div v-else-if="data?.file.includes('pdf')"
        class="d-flex align-center justify-center"
        style="border: 1px solid #C51C1C; background-color: #f9e8e8; padding: 0px 8px"
        :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
      >
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #C51C1C">
          PDF
        </div>
      </div>
      <!-- json -->
      <div v-else-if="data?.file.includes('json')"
        class="d-flex align-center justify-center"
        style="border: 1px solid #8A8DA8; background-color: #f2f2f2; padding: 0px 8px"
        :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
      >
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8">
          Json
        </div>
      </div>
    </div>
    <!-- rpa result -->
    <div v-else-if="data?.category === 'rpa'"
      class="d-flex align-center justify-center"
      style="border: 1px solid #F27603; background-color: #fef1e5; padding: 0px 8px"
      :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
    >
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #F27603">
        RPA
      </div>
    </div>
    <!-- common -->
    <div v-else
      class="d-flex align-center justify-center"
      style="border: 1px solid #0F783E; background-color: #e7f1eb; padding: 0px 8px"
      :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
    >
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #0F783E">
        Common
      </div>
    </div>
  </div>
  <!-- rpa -> result_file -->
  <div v-else-if="data?.data_type === 'result_file'"
    class="d-flex align-center justify-center"
    style="border: 1px solid #F27603; background-color: #fef1e5; padding: 0px 8px"
    :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
  >
    <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #F27603">
      RPA
    </div>
  </div>
  <!-- common -->
  <div v-else
    class="d-flex align-center justify-center"
    style="border: 1px solid #0F783E; background-color: #e7f1eb; padding: 0px 8px"
    :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
  >
    <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #0F783E">
      Common
    </div>
  </div>
</div>
